var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6563 17.8593C21.3375 18.028 21.0094 18.178 20.6719 18.2999C19.5938 18.703 18.4594 18.9093 17.3063 18.9093C12.8719 18.9093 9.00942 15.8624 9.00942 11.9437C9.0188 10.8749 9.60942 9.89053 10.5469 9.38428C6.53442 9.55303 5.50317 13.7343 5.50317 16.1812C5.50317 23.1093 11.8875 23.8124 13.2657 23.8124C14.0063 23.8124 15.1219 23.5968 15.7969 23.3812L15.9188 23.3437C18.5063 22.453 20.7 20.7093 22.1625 18.3937C22.275 18.2155 22.2188 17.9905 22.05 17.878C21.9282 17.803 21.7782 17.7937 21.6563 17.8593Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.6563 17.8593C21.3375 18.028 21.0094 18.178 20.6719 18.2999C19.5938 18.703 18.4594 18.9093 17.3063 18.9093C12.8719 18.9093 9.00942 15.8624 9.00942 11.9437C9.0188 10.8749 9.60942 9.89053 10.5469 9.38428C6.53442 9.55303 5.50317 13.7343 5.50317 16.1812C5.50317 23.1093 11.8875 23.8124 13.2657 23.8124C14.0063 23.8124 15.1219 23.5968 15.7969 23.3812L15.9188 23.3437C18.5063 22.453 20.7 20.7093 22.1625 18.3937C22.275 18.2155 22.2188 17.9905 22.05 17.878C21.9282 17.803 21.7782 17.7937 21.6563 17.8593Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90943 22.6311C9.07505 22.1154 8.35318 21.4311 7.7813 20.6342C5.31568 17.2592 6.0563 12.5248 9.4313 10.0592C9.78755 9.80606 10.1532 9.57168 10.5469 9.38418C10.8376 9.24356 11.3344 8.99981 12.0001 9.00918C12.9469 9.01856 13.8376 9.46856 14.4094 10.2279C14.7844 10.7342 15.0001 11.3436 15.0094 11.9811C15.0094 11.9623 17.3063 4.51855 7.50943 4.51855C3.3938 4.51855 0.00942882 8.42793 0.00942882 11.8498C-0.00932118 13.6592 0.384429 15.4592 1.1438 17.0998C3.7313 22.6123 10.0313 25.3123 15.8063 23.3904C13.8282 24.0092 11.6719 23.7373 9.90943 22.6311Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M9.90943 22.6311C9.07505 22.1154 8.35318 21.4311 7.7813 20.6342C5.31568 17.2592 6.0563 12.5248 9.4313 10.0592C9.78755 9.80606 10.1532 9.57168 10.5469 9.38418C10.8376 9.24356 11.3344 8.99981 12.0001 9.00918C12.9469 9.01856 13.8376 9.46856 14.4094 10.2279C14.7844 10.7342 15.0001 11.3436 15.0094 11.9811C15.0094 11.9623 17.3063 4.51855 7.50943 4.51855C3.3938 4.51855 0.00942882 8.42793 0.00942882 11.8498C-0.00932118 13.6592 0.384429 15.4592 1.1438 17.0998C3.7313 22.6123 10.0313 25.3123 15.8063 23.3904C13.8282 24.0092 11.6719 23.7373 9.90943 22.6311Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2781 13.9594C14.2031 14.0531 13.9688 14.1938 13.9688 14.4938C13.9688 14.7375 14.1281 14.9719 14.4094 15.1688C15.7594 16.1063 18.3 15.9844 18.3094 15.9844C19.3125 15.9844 20.2875 15.7125 21.15 15.2062C22.9125 14.175 24 12.2906 24 10.2469C24.0281 8.14688 23.25 6.75 22.9406 6.13125C20.9531 2.24063 16.6594 0 12 0C5.4375 0 0.09375 5.26875 0 11.8312C0.046875 8.40937 3.45 5.64375 7.5 5.64375C7.82812 5.64375 9.70312 5.67188 11.4375 6.59063C12.9656 7.39688 13.7719 8.3625 14.325 9.32812C14.9062 10.3313 15.0094 11.5875 15.0094 12.0938C15.0094 12.5906 14.7563 13.3406 14.2781 13.9594Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2781 13.9594C14.2031 14.0531 13.9688 14.1938 13.9688 14.4938C13.9688 14.7375 14.1281 14.9719 14.4094 15.1688C15.7594 16.1063 18.3 15.9844 18.3094 15.9844C19.3125 15.9844 20.2875 15.7125 21.15 15.2062C22.9125 14.175 24 12.2906 24 10.2469C24.0281 8.14688 23.25 6.75 22.9406 6.13125C20.9531 2.24063 16.6594 0 12 0C5.4375 0 0.09375 5.26875 0 11.8312C0.046875 8.40937 3.45 5.64375 7.5 5.64375C7.82812 5.64375 9.70312 5.67188 11.4375 6.59063C12.9656 7.39688 13.7719 8.3625 14.325 9.32812C14.9062 10.3313 15.0094 11.5875 15.0094 12.0938C15.0094 12.5906 14.7563 13.3406 14.2781 13.9594Z",
    fill: "url(#paint5_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.50355,
    y1: 16.5955,
    x2: 22.2176,
    y2: 16.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7368 16.7283) scale(8.94098 8.49299)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.3223,
    y1: 9.351,
    x2: 3.88111,
    y2: 20.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.61961 18.657) rotate(-81.3826) scale(13.4435 10.8632)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.42359 4.44307) rotate(92.2911) scale(18.9892 40.4492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5057 7.25679) rotate(73.7366) scale(9.12387 7.42096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.3190b44dbdaf9b3c55c66726806e2b7d.svg";
export { ForwardRef as ReactComponent };